/**
 * The thinking habit in games (docs/PATH-V2.md §7.4, §3.6 p.24): 👀 «Что он хочет?» after the bot's move and 🚦
 * «Безопасно?» before the child's — the habit games of stages 1–2 with the path on (core `coach/lesson/habit.ts`
 * picks a wording and puts `say: [{ pool, n }]` on a 'pathLesson' event).
 *
 * Glossary §3.2: «достаёт», «даром», «под ударом»; no squares in speech; ≤ 2 short sentences. Praise is the PROCESS in
 * the present tense («Думаешь — и ход безопасный!», §3.4 p.18); «не спеши» at most once a game and never a reproach.
 * A wording is ADDED, never edited once recorded.
 *
 * Pools:
 * - `v3.path.habit.safe` — 🚦 before the child's move (about every 3rd move at first, then rarer);
 * - `v3.path.habit.want` — 👀 after the bot's move whose piece glows with its «достаёт» lines;
 * - `v3.path.habit.praise` — a tempting losing move was there and the child played a safe one;
 * - `v3.path.habit.slow` — a hasty move gave a piece away (once a game).
 */
import type { LessonWording } from '../teaching/types.ts';

export const HABIT_POOL = {
  safe: 'v3.path.habit.safe',
  want: 'v3.path.habit.want',
  praise: 'v3.path.habit.praise',
  slow: 'v3.path.habit.slow',
} as const;

export const PATH_HABIT_LINES: Record<string, LessonWording[]> = {
  [HABIT_POOL.safe]: [{ t: 'Светофор! Перед ходом спросим себя: безопасно?' }, { t: 'Стоп, светофор. Никого не отдаём даром?' }],
  [HABIT_POOL.want]: [{ t: 'Что он хочет? Смотри, куда достаёт его фигура.' }, { t: 'Соперник сходил. Что он хочет?' }],
  [HABIT_POOL.praise]: [{ t: 'Думаешь — и ход безопасный!' }, { t: 'Не спешишь — и фигуры целы!' }],
  [HABIT_POOL.slow]: [{ t: 'Не спеши! Сначала посмотрим, кто под ударом.' }, { t: 'Ой, мы поспешили. Перед ходом — светофор!' }],
};
